import { inject } from 'inversify';
import { urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

import { IBranchWithDeliveryPoint } from '../interfaces';
import { BranchMapperWithDeliveryPoint } from '../mappers';

export type IGetBranchesWithDeliverPointsRepoResponse = IRepoResponse<200, { data: IBranchWithDeliveryPoint[]; total: number }> | IRepoResponse<400 | 500, string>;

export type IGetBranchesWithDeliverPointsRepo = IRepo<[any], IGetBranchesWithDeliverPointsRepoResponse>;

export const GetBranchesWithDeliverPointsRepoType = Symbol.for('GetBranchesWithDeliverPointsRepo');

@bind(GetBranchesWithDeliverPointsRepoType)
export class GetBranchesWithDeliverPointsRepo implements IGetBranchesWithDeliverPointsRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(query: object) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/branches', query) });

      if (result.status === 200) {
        const data: IBranchWithDeliveryPoint[] = result.data.data.map((user) => BranchMapperWithDeliveryPoint.toDomain(user));
        const total: number = result.data.total;

        return {
          status: 200 as 200,
          response: {
            data,
            total,
          },
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
